import React, { Fragment } from 'react'
import MealCard from './components/MealCard'
import Detail from './components/Details'
// import Nutrition from './components/Nutrition'
import Ingredients from './components/Ingredients'
import FinalSteps from './components/FinalSteps'
import { mealSkeleton } from './components/MealCard/skeleton'

const MealDetailSkeleton = ({ preloadedMealDetail }) => {
  return (
    <Fragment>
      <MealCard
        isLoading
        order={[]}
        mealDetail={mealSkeleton}
        preloadedMealDetail={preloadedMealDetail}
      />
      <Detail isLoading mealDetail={mealSkeleton} />
      {/* <Nutrition isLoading mealDetail={mealSkeleton} /> */}
      <Ingredients isLoading mealDetail={mealSkeleton} />
      <FinalSteps isLoading mealDetail={mealSkeleton} />
    </Fragment>
  )
}

export default MealDetailSkeleton



// WEBPACK FOOTER //
// ./src/modules/MealDetail/MealDetailSkeleton.jsx